export function formatDate(s: string | null | undefined): string {
  if (!s) return "";
  const d = new Date(s);
  if (Number.isNaN(d.getTime())) return s;
  return d.toLocaleDateString();
}

export function formatDateTime(s: string | null | undefined): string {
  if (!s) return "";
  const d = new Date(s);
  if (Number.isNaN(d.getTime())) return s;
  return d.toLocaleString();
}

export function formatCurrency(n: number | null | undefined): string {
  if (n === null || n === undefined) return "";
  return new Intl.NumberFormat(undefined, { style: "currency", currency: "AUD" }).format(n);
}

export function formatBool(v: unknown): string {
  return v ? "Yes" : "No";
}
